import { Dispatch, SetStateAction } from "react";
import {
  TextField,
  CircularProgress,
  Typography,
  Box,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { Control, Controller } from "react-hook-form";
import { Global, css } from "@emotion/react";

interface AccountAutocompleteProps {
  control: Control;
  options: any[];
  name: string;
  setInputValue: Dispatch<SetStateAction<{}>>;
  loading?: boolean;
  open?: boolean;
  onOpen: () => void;
  onClose: () => void;
  defaultValue?: any;
  error?: boolean;
  helperText?: string;
}

export default function AccountAutocomplete({
  control,
  options,
  name,
  loading,
  open,
  onOpen,
  onClose,
  defaultValue,
  error,
  helperText,
}: AccountAutocompleteProps) {
  return (
    <>
      <Controller
        render={({ onChange, onBlur, value }) => (
          <Autocomplete
            onBlur={onBlur}
            inputValue={value}
            options={options.sort((a, b) => a.index - b.index)}
            disableClearable
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            getOptionLabel={(option) => option.nickname || ""}
            renderOption={(option) => (
              <Typography style={{ padding: "8px 12px" }}>
                {option.nickname}
              </Typography>
            )}
            onInputChange={(_e, newInputValue) => {
              onChange(newInputValue);
            }}
            defaultValue={defaultValue}
            freeSolo
            ListboxComponent={({ children, ...rest }) => (
              <ul {...rest}>
                <Box fontSize={12} display="flex" alignItems="center" pl={2}>
                  <ErrorOutlineIcon
                    color="error"
                    fontSize="inherit"
                    style={{ marginRight: 2 }}
                  />
                  <Typography variant="caption" style={{ fontStyle: "italic" }}>
                    You have already started quoting a similar company. Did you
                    mean of these?
                  </Typography>
                </Box>
                {children}
              </ul>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Applicant Name"
                placeholder="ACME Inc."
                error={error}
                helperText={helperText}
                variant="outlined"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                required
              />
            )}
            classes={{
              option: "acc-autocomplete-option",
            }}
          />
        )}
        loading={loading}
        defaultValue={defaultValue}
        name={name}
        control={control}
      />
      <Global
        styles={css`
          .acc-autocomplete-option {
            padding-top: 0;
            padding-bottom: 0;
            padding-left: 0;
            padding-right: 0;
          }
        `}
      />
    </>
  );
}
